<template>
	<div
		id="transport"
		ref="transport_ref"
		class="transport col-12 px-0 d-none d-md-flex my-4 font-body font-size-16 font-weight-default"
	>
		<div class="w-100">
			<div class="title-container d-flex justify-content-between">
				<h3 class="title-4 text-grey-800 mb-2">
					{{ "1. " }}{{ store.state.content.planner_optForPackages}}
				</h3>
				<!-- <div id="transport-show-more" class="cursor-pointer">
					<u class="link-large-underline link-default">{{
						store.state.content.planner_prestationsMoreInfo
					}}</u>
					<svg style="color: var(--primary-blue);" width="10" height="10" class="icon">
						<use xlink:href="#___icon___chevron-right-bold"></use>
					</svg>
				</div> -->
			</div>

			<div class="tabs-wrapper d-flex flex-row nowrap mt-4">
				<div
					v-for="(option, option_i) in options"
					@click.stop="handleSwitch(option.value)"
					class="tab col"
					:class="
						store.state.transportCheckbox === option.value
							? 'active font-weight-700'
							: ''
					"
					:key="option_i"
				>
					<div class="tab-inner-wrapper">
						<div class="d-flex justify-content-end align-items-center">
							<RadioCircle
								:active="store.state.transportCheckbox === option.value"
								:colorDefault="colors.darkBlue"
								:colorActive="'white'"
								:additionalClasses="'me-1 me-xl-3'"
							/>
						</div>
						<span class="d-flex justify-content-center align-items-center">
							{{ option.label }}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { nextTick, computed, ComputedRef } from "vue"
//import store from "@/vue/planning/store/store"
import RadioCircle from "@/vue/common/radioCircle.vue"

// computed
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"
import availableNonTransportPackageCodes from "@/vue/planning/computed/availableNonTransportPackageCodes"

// config
import colors from "@/config/colors"

import { useStore } from "vuex"
const store = useStore();

class SwitchOption {
	label: string
	value: boolean
	constructor(label: string, value: boolean) {
		this.label = label
		this.value = value
	}
}

// computed
const options: ComputedRef<SwitchOption[]> = computed(() => {
	const { content } = store.state
	const switchOptions: SwitchOption[] = []

	const switchContent: string = store.getters.flightPackCodeSelected ? content.planner_formulaWithFlight : content.planner_formulaWithTransport
	switchOptions.push(
		new SwitchOption(switchContent, true)
	)

	// If we have other options besides a train pack, add the switch to select not transport packs
	if (
		availableNonTransportPackageCodes.value &&
		availableNonTransportPackageCodes.value.length
	) {
		switchOptions.push(new SwitchOption(content.planner_noTransport, false))
	}

	return switchOptions
})



// methods
const handleSwitch = (bool: boolean) => {
	store.commit("setTransport", bool)
	store.commit("setTransportationSelected", bool)
	store.dispatch("setPackage", packagesToDisplay.value[0].codePackage)
	store.dispatch("selectTransportWithDefaultPackage", bool)
}
</script>

<style scoped>
.tab-inner-wrapper {
	display: grid;
	grid-template-columns: 70px 1fr 70px;
}

.tab {
	background: white;
	border-bottom: 1px solid #dee2e6;
	flex-grow: 1;
	height: 70px;
	border-radius: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: background 150ms ease-in-out, color 150ms ease-in-out,
		border 150ms ease-in-out;
	position: relative;
}

.tab:not(.active):hover {
	color: var(--primary-blue);
	border: 1px solid var(--primary-blue);
}
.tab:not(:first-child) {
	border-right: 1px solid #dee2e6;
}
.tab:not(:last-child) {
	border-left: 1px solid #dee2e6;
}
.tab:last-child,
.tab:first-child {
	border-left: none;
	border-right: none;
}

.tab:first-child {
	border-top-left-radius: 16px;
	border-bottom-left-radius: 16px;
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
}

.tab:last-child {
	border-top-right-radius: 16px;
	border-bottom-right-radius: 16px;
	border-top-left-radius: 0px;
	border-bottom-left-radius: 0px;
}

.tab.active {
	background: var(--primary-blue);
	border: none;
	color: white;
}

.tabs-wrapper {
	border-radius: var(--border-radius-secondary);
	/* overflow: hidden; */
}



</style>